import React, { useState, useEffect } from 'react';
import AuthLayout from '../auth-layout';
import { ReactComponent as VerifyAccountIcon } from 'assets/icons/verify-account.svg';

import { STORAGE_KEYS } from 'utils/constants';
import { apiService } from 'services/base.service';
import { formatPhoneNumber } from '@cokitchen/cokitchen-components';

const VerifyAccount = () => {
  const verificationEmail = localStorage.getItem(STORAGE_KEYS.NEW_USER_EMAIL);
  const verificationPhoneNumber = localStorage.getItem(STORAGE_KEYS.NEW_USER_PHONE_NUMBER);
  const [countdown, setCountdown] = useState(30);

  const sendVerificationEmail = async () => {
    await apiService.post('auth/send-verification-email', {
      data: {
        phone_number: formatPhoneNumber(verificationPhoneNumber ?? '')
      }
    });
  };

  useEffect(() => {
    sendVerificationEmail();
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);

    if (countdown === 0) {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [countdown]);

  return (
    <AuthLayout title={'Verify Account'} onConfirmText='Continue' hideButton>
      <div className='text-sm'>
        <p className='text-[#6F7376]  mt-[-24px] mb-6'>
          A verification link has been sent to
          <span className='text-[#0080E5] text-base font-medium'> {verificationEmail}</span> Please
          check your email and click the link to confirm
        </p>
        <VerifyAccountIcon />

        <p className='text-gray-5 mt-6'>
          Didn’t receive email?{' '}
          {countdown === 0 ? (
            <span
              className='underline text-medium cursor-pointer font-medium text-blue-4 hover:text-blue-5'
              onClick={() => {
                sendVerificationEmail();
                setCountdown(30);
              }}>
              Resend
            </span>
          ) : (
            <span className='text-[#2E3031] text-medium font-medium'>
              Resend in {countdown} seconds
            </span>
          )}
        </p>
      </div>
    </AuthLayout>
  );
};

export default VerifyAccount;
